import Link from "next/link";
import Image from "next/image";

interface ViewAllButtonProps {
  href: string;
  title?: string;
  label?: string;
  className?: string;
  iconClass?: string;
}

export default function ViewAllButton({
  href,
  title = "View All Specs",
  label,
  className = "",
  iconClass,
}: ViewAllButtonProps) {
  const visibleLabel = label ?? title;
  return (
    <Link
      href={href}
      title={title}
      className={`items-center gap-2 px-5 py-2.5 rounded-[12px] bg-white/10 border border-white/20 backdrop-blur-md text-white text-sm font-medium ${className}`}
    >
      <span>{visibleLabel}</span>

      <Image
        src={`${process.env.NEXT_PUBLIC_CDN_STATIC_URL}view-all-arrow.svg`}
        alt={visibleLabel}
        title={title}
        width={20}
        height={20}
        className={iconClass}
      />
    </Link>
  );
}
